// src/i18n/en/summary.ts
// «Resumen» (mockup 05) — route /summary, Dirección.
export const summary = {
  name: 'Summary |||| Summary',
  subtitle: 'How arrivals at the selected properties happen and get resolved',

  tiles: {
    arrivals: 'Arrivals',
    arrivalsRoommatik: 'Reservations with Roommatik activity',
    arrivalsMixed: 'Arrivals and reservations with activity',
    resolvedWithoutReception: 'Self-service arrivals',
    chargedSelfService: 'Charged in self-service',
    resolvedWithoutReceptionDetail: '%{count} of %{total} arrival |||| %{count} of %{total} arrivals',
    chargedSelfServiceDetail: '%{count} reservation charged |||| %{count} reservations charged',
  },

  source: {
    hotelSystem: "Arrivals from the hotel's reservation list, without cancelled and no-show reservations.",
    roommatik:
      'The hotel does not share its reservation list with Roommatik: the reservations that went through a Roommatik channel are counted, leaving out guests who did everything at reception.',
    mixed:
      "From the hotel's reservation list (without cancelled and no-show): %{hotelSystem}. Reservations with Roommatik activity, as the hotel does not share its list: %{roommatik}.",
    mixedCount:
      "%{count} of the %{total} hotels shares its reservation list: its arrivals are those of that list, without cancelled and no-show reservations. For the rest, the reservations with Roommatik activity are counted. Properties shows the case of each hotel. |||| %{count} of the %{total} hotels share their reservation list: their arrivals are those of that list, without cancelled and no-show reservations. For the rest, the reservations with Roommatik activity are counted. Properties shows the case of each hotel.",
  },

  rows: {
    title: 'How they arrived',
    columns: {
      count: 'Count',
      pct: '%',
      previous: 'Previous period',
      chainAvg: 'Chain average',
      chainAvgShare: 'Chain average (%)',
    },
    arrivals: 'Arrivals',
    invited: 'Invited',
    preCheckInDone: 'Pre-check-in done',
    preCheckInPartial: 'Pre-check-in partial',
    keyWithoutReception: 'Self-service (kiosk, phone or dispenser)',
    airLobby: 'Air Lobby',
    kioskWithoutPreCheckIn: 'Kiosk or phone without pre-check-in',
    noRecord: 'No check-in on record',
    availableSoon: 'Coming soon',
  },

  view: {
    count: 'Count',
    pct: '%',
  },

  byDay: {
    title: 'Arrivals by day',
    description: 'Each arrival is in one series only, in this order: Air Lobby, pre-check-in done, kiosk or phone, another channel; with nothing, depending on whether the day is closed.',
    series: {
      withPreCheckIn: 'With pre-check-in',
      kioskWithoutPreCheckIn: 'Kiosk or phone without pre-check-in',
      airLobby: 'Air Lobby',
      otherCheckIn: 'Check-in on another channel',
      noRecord: 'No pre-check-in or check-in',
      pending: 'Pending (current day)',
    },
  },

  checkInByChannel: {
    title: 'Check-in by channel',
    other: 'Other channels',
    columns: {
      channel: 'Channel',
      checkIns: 'Check-ins',
      pctOfArrivals: '% of arrivals',
      withPreCheckIn: 'With pre-check-in',
      medianSeconds: 'Median duration',
      keysDelivered: 'Keys delivered',
      charged: 'Charged on the channel',
    },
  },

  noRecord: {
    line:
      '%{count} arrival with no check-in on record (%{pct} of the arrivals of closed days) |||| %{count} arrivals with no check-in on record (%{pct} of the arrivals of closed days)',
  },

  estimatedArrivalDates: 'Estimated arrival date on %{count} reservation |||| Estimated arrival date on %{count} reservations',

  export: {
    row: 'Item',
  },

  help: {
    title: 'Summary',
    description:
      'The overview of arrivals at the selected properties: how many there were, how they were resolved and which channel they used for check-in.',
    features: {
      source:
        "If the hotel shares its reservation list, \"Arrivals\" are those of that list, without cancelled and no-show reservations; otherwise the reservations with Roommatik activity are counted. The note under the figures says which applies to each hotel.",
      rows: 'The "How they arrived" table compares the period with the previous one and, where applicable, the chain average.',
      byDay: 'The daily chart puts each arrival in one series only; days without arrivals show as zero.',
      channel: 'Check-in by channel shows how many arrivals were resolved in each channel and how long it took; "Other channels" holds the rest, so the rows add up to the arrivals with check-in.',
      selfService: '"Self-service arrivals" counts arrivals that checked in at the kiosk or on the phone, or took the key from the dispenser. Its change is given in percentage points (pp).',
      noRecord:
        '"No check-in on record" only counts closed days, and its percentage is over the arrivals of those days: the current day does not count until the hotel closes its business day (usually at 04:00).',
    },
    tips: {
      compare: 'Turn on "Compare with the previous period" to see the trend.',
    },
  },
};

export default summary;
